export class DisplayedRatePlanCode {

  constructor(public ratePlanCode: string, public closeable: boolean) {
    this.ratePlanCode = ratePlanCode;
    this.closeable = closeable;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/rate-plan-code/rate-plan-code/displayed-rate-plan-code.ts